import React from "react";
import "../../Assets/Css/Holiday.scss";
import { useLocation, useNavigate } from "react-router-dom";

const ViewSpecialday = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state?.data?.allData;

  return (
    <>
      <div className="view-holiday-container">
        <div className="page-title">
          <h4>Special Day Details</h4>
          <div className="edit-btn">
            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="view-card">
          <div className="date-part">
            <div className="date-title">Date:</div>
            <div className="date">{data?.date}</div>
          </div>
          <div className="occasion-part">
            <div className="occasion-title">Occasion:</div>
            <div className="occasion">{data?.occasion}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSpecialday;
